export default {"src":"/_next/static/media/map-pin.53620108.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};